"use client";
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from './context/SettingsContext';
import { CDN_URL, IMAGE_BASE_URL } from './config/apiconfig';
import { useLocation, useNavigate } from "react-router-dom";
import {
  Grid3X3,
  Package,
  ShoppingCart,
  Users,
  BarChart3,
  Settings,
  ChevronLeft,
  ChevronRight,
  Home,
  FileText,
  Tag,
  Truck,
  MessageSquare,
  Palette,
  HelpCircle,
  Layers,
  CreditCard,
  Send,
  Bell,
  BadgePercent,
  ClipboardListIcon,
  Plus,
  TagIcon,
  Phone,
  Percent,
  Receipt,
  Sparkles,
  CardSim,
  CreditCardIcon,
  IndianRupee,
  ReceiptIndianRupee,
} from 'lucide-react';
import LogoutButton from './LogoutButton';
import { useAppContext } from '../App';

const DashboardSidebar = ({ activeSection }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { getProfile } = useSettings();
  const [profile, setProfile] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);
  // ✅ Tooltip state — single floating tooltip for all menu items
  const [tooltip, setTooltip] = useState({ label: '', y: 0, visible: false });

  useEffect(() => {
    const fetchProfile = async () => {
      const adminId = localStorage.getItem("admin_id");
      if (!adminId) return;

      const response = await getProfile(adminId);

      if (response?.status === 200) {
        setProfile(response.data);
      }
    };

    fetchProfile();
  }, [getProfile]);

  const { isCollapsed, setIsCollapsed, isMobileMenuOpen, setIsMobileMenuOpen } = useAppContext();

  const menuItems = [
    { id: 'dashboard',     label: 'Dashboard',               icon: Home,            path: '/dashboard',    badge: null },
    { id: 'categories',    label: 'Categories',               icon: Grid3X3,         path: '/categories',   badge: null },
    { id: 'subcategories', label: 'Sub-Categories',           icon: Tag,             path: '/subcategories',badge: null },
    { id: 'modals',        label: 'Models',                   icon: Layers,          path: '/modals',       badge: null },
    { id: 'Prdoucttype',   label: 'Product Types',            icon: TagIcon,         path: '/producttype',  badge: null },
     // ── Product Attributes dropdown ──────────────────────────────────
    {
      id: 'product-attributes',
      label: 'Product Attributes',
      icon: Palette,
      children: [
        { id: 'materials', label: 'Materials', path: '/product-attributes/materials', icon: Package   },
        { id: 'colours',   label: 'Colours',   path: '/product-attributes/colours',   icon: Palette   },
        { id: 'styles',    label: 'Styles',    path: '/product-attributes/styles',    icon: Sparkles  },
      ],
    },
    { id: 'products',      label: 'Products',                 icon: Package,         path: '/products',     badge: null },

   
    // ────────────────────────────────────────────────────────────────
    { id: 'order-types',        label: 'Order-Types',                   icon: CreditCardIcon,    path: '/order-types',       badge: null },

    { id: 'orders',        label: 'Orders',                   icon: ShoppingCart,    path: '/orders',       badge: null },
    { id: 'transactions',  label: 'Transactions',             icon: CreditCard,      path: '/transactions', badge: null },
    {
      id: 'customers',
      label: 'Customers',
      icon: Users,
      children: [
        { id: 'customer-dashboard', label: 'Customer Dashboard', path: '/customers-coming-soon' },
        { id: 'customers-list',     label: 'Customers',          path: '/customers'             },
      ],
    },
     {
      id: 'masters',
      label: 'Masters',
      icon: Layers,
      children: [
        { id: 'suppliers',         label: 'Suppliers',         path: '/suppliers' },
        { id: 'states',            label: 'States',            path: '/states' },
        { id: 'districts',         label: 'Districts',         path: '/districts' },
        { id: 'mandals',           label: 'Mandals',           path: '/mandals' },
        { id: 'cities',            label: 'Cities',            path: '/cities' },
        { id: 'expense',           label: 'Expense',           path: '/expenses' },
        { id: 'items',             label: 'Items',             path: '/items' },
      ],
    },
    {
      id: 'vouchers',
      label: 'Vouchers',
      icon: Receipt,
      children: [
        { id: 'expense-voucher',   label: 'Expense Voucher',   path: '/expensevouchers' },
        { id: 'purchase-voucher',  label: 'Purchase Voucher',  path: '/purchase-voucher' },
        { id: 'payment-voucher',   label: 'Payment Voucher',   path: '/payment-voucher' },
      ],
    },
    // { id: 'shippingmethods',label: 'Shipping Methods',        icon: Truck,           path: '/shippingmethods',badge: null },
    { id: 'reviews',       label: 'Reviews',                  icon: MessageSquare,   path: '/reviews',      badge: null },
    { id: 'faqs',          label: 'FAQs',                     icon: HelpCircle,      path: '/faqs',         badge: null },
    { id: 'report-types',  label: 'Suggestion & Issue Types', icon: ClipboardListIcon,path: '/reporttypes', badge: null },
    { id: 'reports',       label: 'Suggestions & Issues',     icon: BarChart3,       path: '/reports',      badge: null },
    { id: 'discount',      label: 'Discount Types',           icon: BadgePercent,    path: '/discount',     badge: null },
    { id: 'offers',        label: 'Coupons',                  icon: Tag,             path: '/coupons',      badge: null },
    { id: 'Notifications', label: 'Notifications',            icon: Bell,            path: '/notification', badge: null },
    { id: 'contact',       label: 'Contact',                  icon: Phone,           path: '/contact',      badge: null },
    { id: 'tax',           label: 'Tax',                      icon: ReceiptIndianRupee,         path: '/tax',          badge: null },
    { id: 'settings',      label: 'Settings',                 icon: Settings,        path: '/settings',     badge: null },
   
  ];

  const isActive = (path) => location.pathname === path;

  // Returns true if any child of a dropdown is the current route
  const isChildActive = (children = []) =>
    children.some((child) => location.pathname === child.path);

  const [isDesktop, setIsDesktop] = React.useState(
    typeof window !== "undefined" ? window.innerWidth >= 1024 : false
  );

  React.useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto-open the dropdown whose child is the active route on mount / route change
  useEffect(() => {
    const activeParent = menuItems.find(
      (item) => item.children && isChildActive(item.children)
    );
    if (activeParent) setOpenMenu(activeParent.id);
  }, [location.pathname]);

  // ✅ Hide tooltip whenever the route changes
  useEffect(() => {
    setTooltip((t) => ({ ...t, visible: false }));
  }, [location.pathname]);

  const handleMenuItemClick = () => {
    setIsMobileMenuOpen(false);
    setTooltip((t) => ({ ...t, visible: false }));
  };

  return (
    <>
      {/* Mobile backdrop */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      {/* ✅ overflow-hidden — tooltip uses position:fixed so it escapes the aside naturally */}
      <aside className={`
        bg-white bg-opacity-80 backdrop-blur-lg border-r border-orange-200
        transition-all duration-300 flex flex-col h-screen fixed left-0 top-0 z-40
        overflow-hidden
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0
        ${isCollapsed ? 'lg:w-20' : 'lg:w-64'} w-64
      `}>

        {/* Header */}
        <div className={`p-4 border-b border-orange-200 flex-shrink-0 ${isCollapsed && isDesktop ? 'lg:px-2' : 'lg:px-6'} px-6`}>
          {isCollapsed && isDesktop ? (
            <div className="flex flex-col items-center gap-3">
              <div className="w-10 h-10 bg-gradient-to-br from-teal-600 to-teal-800 rounded-xl flex items-center justify-center">
                <Package className="w-6 h-6 text-white" />
              </div>
              <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                className="p-1.5 hover:bg-orange-100 rounded-lg transition-colors hidden lg:block"
                aria-label="Expand sidebar"
              >
                <ChevronRight className="w-4 h-4 text-gray-600" />
              </button>
            </div>
          ) : (
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
               <div 
      onClick={() => navigate("/settings")}
      className="w-10 h-10 bg-gradient-to-br from-teal-600 to-teal-800 rounded-xl flex items-center justify-center cursor-pointer"
    >
      <img 
        src="https://cdn.acsdev.in/ManaPrint/manaprint_logo_tras.png"
        alt="logo"
        className="w-7 h-7 object-contain"
      />
    </div>
                <div>
                  <h2 className="text-lg font-bold text-teal-800">ManaPrint</h2>
                  <p className="text-xs text-gray-600">Admin Panel</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setIsCollapsed(!isCollapsed)}
                  className="p-2 hover:bg-orange-100 rounded-lg transition-colors hidden lg:block"
                  aria-label="Collapse sidebar"
                >
                  <ChevronLeft className="w-5 h-5 text-gray-600" />
                </button>
                <button
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="p-2 hover:bg-orange-100 rounded-lg transition-colors lg:hidden"
                  aria-label="Close mobile menu"
                >
                  <ChevronLeft className="w-5 h-5 text-gray-600" />
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Navigation Menu */}
        {/* ✅ overflow-y-auto only — no overflow-visible here */}
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
          {menuItems.map((item) => {
            const Icon = item.icon;

            // ── Dropdown menu ────────────────────────────────────────
            if (item.children) {
              const childActive = isChildActive(item.children);
              const isOpen = openMenu === item.id;

              return (
                <div key={item.id}>
                  <button
                    onClick={() => setOpenMenu(isOpen ? null : item.id)}
                    className={`flex items-center gap-3 w-full px-3 py-3 rounded-xl transition-colors
                      ${childActive
                        ? 'bg-orange-100 text-teal-700 font-semibold'
                        : 'text-gray-700 hover:bg-orange-100'
                      }
                      ${isCollapsed && isDesktop ? 'justify-center' : ''}
                    `}
                    onMouseEnter={(e) => {
                      if (isCollapsed && isDesktop) {
                        const rect = e.currentTarget.getBoundingClientRect();
                        setTooltip({ label: item.label, y: rect.top + rect.height / 2, visible: true });
                      }
                    }}
                    onMouseLeave={() => setTooltip((t) => ({ ...t, visible: false }))}
                  >
                    <Icon className="w-5 h-5 flex-shrink-0" />
                    {(!isCollapsed || !isDesktop) && (
                      <>
                        <span className="font-medium flex-1 text-left">{item.label}</span>
                        {/* Chevron rotates when open */}
                        <ChevronRight
                          className={`w-4 h-4 text-gray-400 transition-transform duration-200
                            ${isOpen ? 'rotate-90' : ''}`}
                        />
                      </>
                    )}
                  </button>

                  {/* Children — only show when expanded and open */}
                  {isOpen && (!isCollapsed || !isDesktop) && (
                    <div className="ml-4 mt-1 space-y-0.5 border-l-2 border-orange-100 pl-3">
                      {item.children.map((child) => {
                        const ChildIcon = child.icon;
                        const active = location.pathname === child.path;
                        return (
                          <Link
                            key={child.id}
                            to={child.path}
                            onClick={handleMenuItemClick}
                            className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm transition-colors
                              ${active
                                ? 'bg-orange-200 text-teal-800 font-semibold'
                                : 'text-gray-600 hover:bg-orange-100 hover:text-gray-800'
                              }`}
                          >
                            {ChildIcon && <ChildIcon className="w-4 h-4 flex-shrink-0" />}
                            {child.label}
                          </Link>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            }

            // ── Normal menu item ─────────────────────────────────────
            return (
              <Link
                key={item.id}
                to={item.path}
                onClick={handleMenuItemClick}
                onMouseEnter={(e) => {
                  if (isCollapsed && isDesktop) {
                    const rect = e.currentTarget.getBoundingClientRect();
                    setTooltip({ label: item.label, y: rect.top + rect.height / 2, visible: true });
                  }
                }}
                onMouseLeave={() => setTooltip((t) => ({ ...t, visible: false }))}
                className={`flex items-center gap-3 px-3 py-3 rounded-xl transition-colors
                  ${isActive(item.path)
                    ? 'bg-orange-100 text-teal-700 font-semibold'
                    : 'text-gray-700 hover:bg-orange-100'
                  }
                  ${isCollapsed && isDesktop ? 'justify-center' : ''}
                `}
              >
                <Icon className="w-5 h-5 flex-shrink-0" />
                {(!isCollapsed || !isDesktop) && (
                  <span className="font-medium">{item.label}</span>
                )}
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        <div className={`mt-auto p-4 border-t border-orange-200 flex-shrink-0 ${isCollapsed && isDesktop ? 'lg:px-2' : ''} px-4`}>
          {(!isCollapsed || !isDesktop) && (
            <div className="mb-4 p-3 bg-orange-50 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full overflow-hidden bg-teal-600 flex items-center justify-center">
                  {profile?.image ? (
                    <img
                      src={`${CDN_URL}/${profile.image}`}
                      alt="Profile"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <span className="text-white text-sm font-bold">
                      {profile?.first_name?.charAt(0) || "A"}
                    </span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-800 truncate">{profile?.first_name} {profile?.last_name}</p>
                  <p className="text-xs text-gray-600 truncate">{localStorage.getItem("admin_email")}</p>
                </div>
              </div>
            </div>
          )}
          <LogoutButton isCollapsed={isCollapsed && isDesktop} />
        </div>

      </aside>

      {/* ✅ Tooltip rendered as a SIBLING outside <aside>
          backdrop-blur-lg on aside applies a CSS filter which traps position:fixed children
          inside its own stacking context — moving it here fixes that completely */}
      {tooltip.visible && isCollapsed && isDesktop && (
        <div
          className="fixed z-[9999] px-3 py-2 bg-gray-900 text-white text-sm
                     rounded-lg shadow-lg whitespace-nowrap pointer-events-none
                     -translate-y-1/2"
          style={{ top: tooltip.y, left: '84px' }}
        >
          {/* Arrow pointing left */}
          <div className="absolute right-full top-1/2 -translate-y-1/2
                          border-4 border-transparent border-r-gray-900" />
          {tooltip.label}
        </div>
      )}
    </>
  );
};

export default DashboardSidebar;